import { BaseMappingStep } from './BaseMappingStep'

export class RequiredMappingStep extends BaseMappingStep {
  protected headers = ['Required Field', 'User Field']
}
